import { BenchmarkSettingsContext } from "@/components/BenchmarkSettingsContext"
import withContext from "@/helpers/hoc/withContext"

const withBenchmarkSettingsContext = Component => {
  return withContext(BenchmarkSettingsContext, Component)
}

export default withBenchmarkSettingsContext
